import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";
import moment from "moment";

class PastOccupancyList extends Component {
  canAddOccupancy() {
    const past_occupancies = this.props.past_occupancies.filter(occ => !occ._destroy);
    const pastOccupancies = past_occupancies.filter((occ) => {
      return (
        occ.moved_in_at && moment(occ.moved_in_at).isBefore() && !occ.moved_out_at ||
        occ.moved_in_at && moment(occ.moved_in_at).isBefore() &&
        occ.moved_out_at && moment(occ.moved_out_at).isAfter()
      );
    });

    return (
      this.props.organization['recovery_coaching?'] ||
      this.props.organization['treatment_center?'] ||
      this.props.organization['drug_court_program?'] ||
      this.props.organization['sober_home?'] && pastOccupancies.length == 0
    );
  }

  renderPastEditButton(occupancy) {
    const { isStaffApp } = this.props;

    return isStaffApp ?
      (
        <div className="d-flex justify-content-between">
          <a
            className="mr-2 btn btn-primary"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.editOccupancy(occupancy);
            }}>
            Edit
          </a>
          {occupancy["current?"] && !occupancy["moved_out_at"] &&
            <a
              className="btn btn-primary"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.props.dischargeOccupancy(occupancy);
              }}>
              Discharge
            </a>
          }
        </div>
      ) :
      (
        <div>
          <a
            className="mr-2"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.props.editOccupancy(occupancy);
            }}>
            Edit
          </a>
          {occupancy["current?"] && !occupancy["moved_out_at"] &&
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.props.dischargeOccupancy(occupancy);
              }}>
              Discharge
            </a>
          }
        </div>
      );
  }

  showLabel(type) {
    const { past_occupancies } = this.props;
    return past_occupancies.reduce((acc, curr) => {
      return acc || (
        curr.bed &&
        curr.bed[`${type}_label`]
      );
    }, false);
  }

  render() {
    const past_occupancies = this.props.past_occupancies.filter(occ => !occ._destroy).sort((a, b) => moment(b.moved_in_at) - moment(a.moved_in_at));
    const showRoomLabel = this.showLabel("room");
    const showBedLabel = this.showLabel("bed");
    const { current_user, isStaffApp } = this.props
    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Facility Name</th>
            <th>Length of Stay</th>
            <th>Admit Date</th>
            <th>Est. Length of Stay</th>
            <th>Est. Discharge Date</th>
            <th>Discharged At</th>
            <th>Reason for Discharge</th>
            <th>Post Discharge Destination</th>
            <th>Is Successful Discharge</th>
            {
              showRoomLabel &&
              <th>Room</th>
            }
            {
              showBedLabel &&
              <th>Bed</th>
            }
            {
              showBedLabel &&
              <th>Bed Price</th>
            }
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            past_occupancies.map((occupancy) => {
              const {
                group_id,
                group,
                moved_in_at,
                estimated_length_of_stay,
                estimated_discharge_date,
                post_discharge_destination,
                moved_out_at,
                reason_for_discharge,
                is_successful_discharge
              } = occupancy;
              const lengthOfStay = moment(moved_out_at).diff(moment(moved_in_at), 'days');
              return (
                <tr key={occupancy.id}>
                  <td>{!!occupancy.group ? occupancy.group.name : null}</td>
                  <td>{lengthOfStay ? `${lengthOfStay} days` : null}</td>
                  <td>{moved_in_at ? moment(moved_in_at).format("MM/DD/YYYY") : null}</td>
                  <td>{estimated_length_of_stay}</td>
                  <td>{estimated_discharge_date ? moment(estimated_discharge_date).format("MM/DD/YYYY") : null}</td>
                  <td>{moved_out_at ? moment(moved_out_at).format("MM/DD/YYYY") : null}</td>
                  <td>{reason_for_discharge}</td>
                  <td>{post_discharge_destination}</td>
                  <td>{is_successful_discharge == true ? 'Yes'
                    : (is_successful_discharge == null ? '' : 'No')}</td>
                  {
                    showRoomLabel &&
                    <td>
                      {
                        occupancy.bed &&
                        occupancy.bed.room_label
                      }
                    </td>
                  }
                  {
                    showBedLabel &&
                    <td>
                      {
                        occupancy.bed &&
                        occupancy.bed.bed_label
                      }
                    </td>
                  }
                  {
                    showBedLabel &&
                    <td>
                      {
                        occupancy.bed &&
                        `$${occupancy.bed.price}`
                      }
                    </td>
                  }
                  <td>{
                    this.props.action === "edit" &&
                    (!group || current_user.groups_from_policy.map(group => group.id).filter(id => id == group.id).length > 0) &&
                    this.renderPastEditButton(occupancy)
                  }</td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    )
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    isStaffApp: state.config.isStaffApp,
    current_user: state.current_user,
    past_occupancies: state.past_occupancies,
    organization: state.organization,
    resident: state.resident,
    groups: state.groups,
    action: state.ui.action
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    editOccupancy: (occupancy) => dispatch({ type: "EDIT_OCCUPANCY", payload: occupancy }),
    dischargeOccupancy: (occupancy) => dispatch({ type: "OPEN_DISCHARGE_OCCUPANCY_MODAL", payload: occupancy }),
    newOccupancy: () => dispatch({ type: "NEW_OCCUPANCY" })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PastOccupancyList);
